import React from 'react';
import { useSelector } from 'react-redux';
import block from 'bem-cn';
import Button from 'components/Button';

import './ActiveRequestModal.scss';

const b = block('active-request-modal');

const ActiveRequestModal = ({ item, note, onNoteChange, onClose, onSend }) => {
  const locale = useSelector(state => state.locale.locale);

  if (item === null) return null;

  return (
    <section className={b()}>
      <div className={b('content')}>
        <div className={b('header')}>{locale.requestRejection}</div>

        <div className={b('reject')}>
          {locale.youRejected}
          <span className={b('amount')}>{item.amount}</span>
        </div>

        <div className={b('comment')}>
          {locale.comment} <span className={b('required')}>*</span>
        </div>

        <textarea
          className={b('note')}
          rows={8}
          value={note}
          placeholder={locale.writeExplanation}
          onChange={e => onNoteChange(e.currentTarget.value)}
        />

        <div className={b('actions')}>
          <Button onClick={onSend} disabled={!Boolean(note)}>
            {locale.send}
          </Button>
          <button type="button" className={b('cancel')} onClick={onClose}>
            {locale.cancel}
          </button>
        </div>
      </div>
    </section>
  );
};

export default ActiveRequestModal;
